import Link from 'next/link';

export interface CaseStudyCTAProps {
  ctaLink: string;
  ctaText: string;
}

export function CaseStudyCTA({ ctaLink, ctaText }: CaseStudyCTAProps) {
  return (
    <div className="my-9 flex justify-center px-4 tablet:my-24">
      <Link
        href={ctaLink}
        className="inline-block rounded-md bg-at px-5 py-3 font-soehne font-normal text-white transition-colors hover:bg-[#d63a3a] mobile-only:text-[16px] tablet:px-8 tablet:py-4 tablet:text-[28px]"
      >
        {ctaText}
      </Link>
    </div>
  );
}
